// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import EscortGoods1Item from "./EscortGoods1Item";

const {ccclass, property} = cc._decorator;

@ccclass
export default class EscortGoods1Layer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeList: cc.Node = null;

    @property(cc.Prefab)
    itemPrefab: cc.Prefab = null;
   
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.ESCORT_GOODS1);
        // let title = csvInfos.title;
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }

            // let info = csvInfos[i];
            let nodeItem = cc.instantiate(this.itemPrefab);
            nodeItem.active = true;
            this.nodeList.addChild(nodeItem);

            let script = nodeItem.getComponent(EscortGoods1Item);
            script.setData(i);
        }
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
